/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCoupon } from './BaseCoupon';
const BaseCouponWithoutCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('coupon-without-code')],
]), BaseCoupon);
export class BaseCouponWithoutCode extends BaseCoupon {
    static decode(input) {
        return BaseCouponWithoutCodeParser.decode(input).map(res => new BaseCouponWithoutCode(res));
    }
    static unsafeDecode(input) {
        return BaseCouponWithoutCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCouponWithoutCodeParser.encode(data);
    }
    static schema() {
        return BaseCouponWithoutCodeParser.schema();
    }
}
